import { useEffect, useState } from 'react';

import type { BreakpointName } from 'client-ribbons-base/constants/breakpoints';
import { minBreakpoints as breakpoints } from 'client-ribbons-base/constants/breakpoints';

const sortedBreakpoints = Object.entries(breakpoints).sort((a, b) => (a[1] >= b[1] ? 1 : -1));

interface UseBreakpointOptions {
  /** @deprecated replace the use of this option with expecting the initial value to be XS (render mobile-first) */
  initializeWithLarge?: boolean;
}

export const useBreakpoint = ({
  initializeWithLarge = false,
}: UseBreakpointOptions = {}): BreakpointName => {
  const [screen, setScreen] = useState<number>(
    initializeWithLarge ? breakpoints.XS : breakpoints.L,
  );

  useEffect(() => {
    let frame = 0;

    // Coalesce bursts of resize events into a single state update per animation frame. Reading
    // window.innerWidth and re-rendering on every resize event runs many times per second and re-renders
    // every consumer, which is an INP hazard during a resize interaction.
    const onResize = (): void => {
      if (frame) {
        return;
      }

      frame = window.requestAnimationFrame(() => {
        frame = 0;
        setScreen(window.innerWidth);
      });
    };

    setScreen(window.innerWidth);
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);

      if (frame) {
        window.cancelAnimationFrame(frame);
      }
    };
  }, []);

  const result = sortedBreakpoints.reduce((acc, [name, width]) => {
    if (screen >= width) {
      return name;
    } else {
      return acc;
    }
  }, sortedBreakpoints[0][0]);

  return result as BreakpointName;
};
